<template>
    <va-edit-layout>
        <FinancialEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></FinancialEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
